<ng-container *ngIf="hbRoofHook">
    <sen-app-roof-hook></sen-app-roof-hook>
</ng-container>
<sen-app-beam-distance-control [beamType]="translate.getLng('RAFTER_DISTANCE')" (emitbSuccess)="setbSuccess($event)">
</sen-app-beam-distance-control>